exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".suggestion-container {\r\n    max-height: 75vh;\r\n    overflow-y: auto;\r\n}\r\n\r\n@media only screen and (max-width: 1024px) {\r\n    .with-button {\r\n        margin-top: 0 !important;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .view-all {\r\n        position: absolute !important;\r\n    }\r\n    .dropdown-menu{\r\n        top:50px !important;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width:320px){\r\n    .buttonCustomer{\r\n        width:61px !important;\r\n    \r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/searchbar/searchbar.component.css
// module id = ../../../../../src/app/directive/searchbar/searchbar.component.css
// module chunks = main